// extracted by mini-css-extract-plugin
export default {"example-slide":"styles__example-slide--2GBaS","next-arrow":"styles__next-arrow--5ek7T","back-arrow":"styles__back-arrow--pel1I","disabled":"styles__disabled--VghJO"};